import * as storage from './storage';
import { travelTypes } from '@/_data/travelTypes';

/**
 *
 * @returns {boolean}
 */
export const isInternalIp = () => {
    const bookingData = storage.get('bookingData');
    const testEnvironments = ['development', 'staging', 'integration'];

    return testEnvironments.includes(process.env.VITE_ENV) || (bookingData?.data?.isInternal ?? false);
};

export const setRealBooking = (travelType, value) => {
    const travelTypeList = travelTypes;

    let retObj = {
        realbooking: {},
    };

    if (travelTypeList.indexOf(travelType)) {
        retObj.realbooking[travelType] = value;
        return retObj;
    } else {
        return {};
    }
};
